import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App'
import './index.css'

// 🔧 DEVELOPMENT MODE CHECK - Ensure React is running in development mode
if (import.meta.env.DEV) {
  console.log('🔧 [DEV MODE] React is running in DEVELOPMENT mode - full error messages enabled')
  console.log('🔧 [DEV MODE] NODE_ENV:', import.meta.env.MODE)
} else {
  console.warn('⚠️ [WARNING] React is running in PRODUCTION mode - errors will be minified!')
}

// Suppress known benign errors that are non-critical
const originalError = console.error
console.error = (...args: any[]) => {
  const errorStr = String(args[0])
  
  // Suppress Blink SDK analytics network errors
  if (
    errorStr.includes('Failed to send analytics events') ||
    errorStr.includes('BlinkNetworkError') ||
    (errorStr.includes('Failed to send') && errorStr.includes('analytics'))
  ) {
    console.debug('[Analytics Suppressed]', args)
    return
  }
  
  // Suppress ResizeObserver loop errors (benign Radix UI warning)
  if (
    errorStr.includes('ResizeObserver loop') ||
    errorStr.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    console.debug('[ResizeObserver Suppressed]', args)
    return
  }
  
  // Call original error for all other errors
  originalError.apply(console, args)
}

// Also suppress at global error handler level
window.addEventListener('error', (event) => {
  const errorMsg = event.message || String(event.error)
  
  if (
    errorMsg.includes('Failed to send analytics events') ||
    errorMsg.includes('BlinkNetworkError') ||
    errorMsg.includes('ResizeObserver loop') ||
    errorMsg.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // Prevent error propagation for benign errors
    event.preventDefault()
  }
}, true)

// Suppress unhandled promise rejection for analytics errors
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const reasonStr = String(reason)
  
  if (
    reasonStr.includes('Failed to send analytics events') ||
    reasonStr.includes('BlinkNetworkError') ||
    reasonStr.includes('Network request failed')
  ) {
    // Prevent error propagation for analytics-related errors
    event.preventDefault()
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Toaster position="top-right" />
    <App />
  </React.StrictMode>,
) 